var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDrop = function SvgDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "0.75rem",
    viewBox: "0 0 20 14.667"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19.784 14.664-4.814-.585a.196.196 0 0 1-.158-.132.2.2 0 0 1 .044-.202l1.433-1.398-5.453-5.531L8.373 9.31a.388.388 0 0 1-.547 0L.054 1.442a.21.21 0 0 1 0-.282L1.147.054a.194.194 0 0 1 .268 0l6.69 6.762 2.453-2.484a.399.399 0 0 1 .546 0l6.556 6.637 1.433-1.45a.194.194 0 0 1 .2-.045c.07.024.12.086.13.16L20 14.507a.184.184 0 0 1-.216.156z"
  })));
};
export default SvgDrop;